import React from "react";

const leftBar= {
  position: 'fixed',
  left: 0
}

const directoryHighlight = {
  fontFamily: 'Montserrat',
  fontSize: '14px',
  fontWeight: 300,
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: 'normal',
  letterSpacing: '2.3px',
  color: 'rgba(0, 0, 0, 0.87)',
}

const directory = Object.assign({opacity: 0.2}, directoryHighlight);
const listStyling = Object.assign({paddingLeft: '45px'}, directoryHighlight);

const betweenElement =  {
  width: '1px',
  margin: '0 auto',
  backgroundColor: '#979797'
}

const betweenElementActive =  {
  width: '5px',
  margin: '0 auto',
  backgroundColor: '#445074',
  borderRadius: '6px'
}

const extraLine = {
  height: '118px',
  paddingLeft: '15px'
}

const widthControl = {
  width: '300px'
}

class Directory extends React.Component {
  constructor(props) {
    super(props);
    var initState = this.props.numberOfSlides;
    var stateArray = [];

    for (var i = 0; i < initState; i++) {
      if(i == 0){
        stateArray[i] = true;
      } else{
        stateArray[i] = false;
      }
    }
    this.state = {stateArray};
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeSlide !== prevProps.activeSlide) {
      var stateArray = [];
      for (var i = 0; i < this.props.numberOfSlides; i++) {
        if(i === this.props.activeSlide){
          stateArray[i] = true;
        } else{
          stateArray[i] = false;
        }
      };
      this.setState({stateArray});
    }
  }

  render() {

    var namesList = this.props.slideNames.map(function(name,index){
        return (
          <div class = 'row w-100'>
            <div class = 'col-5' style = {{textAlign: 'center', padding: '9px'}}>0{index+1}</div>
            <div class = 'col-2'><div class = 'h-100' style = {this.state.stateArray[index] ? betweenElementActive : betweenElement}></div></div>
            <div class = 'col-5' style = {this.state.stateArray[index] ? directoryHighlight : directory}><div style = {{padding : '9px'}}>{name}</div></div>
        </div>);
    }, this)

    return (
      <div class="container d-flex h-100" style = {leftBar}>
          <div class="justify-content-center align-self-center d-none d-sm-none directory" style = {widthControl}>
            <div class = 'hidden-xs' style = {extraLine}><div class = 'h-100' style = {betweenElement}></div></div>
            <div class = 'hidden-xs' style = {listStyling}>
              { namesList }
            </div>
            <div class = 'hidden-xs' style = {extraLine}><div class = 'h-100' style = {betweenElement}></div></div>
          </div>
      </div>
    )
  }
}

export default Directory;



// WEBPACK FOOTER //
// ./src/components/Directory.js